import type { Maybe } from '@/types'

export default <T>(statuses: Maybe<T[]> | false, statusId: T | undefined) => {
  if (statuses === null || statuses === undefined) return false

  // status check disabled, returns true
  if (statuses === false) return true

  if (statusId) {
    return statuses.includes(statusId)
  }
  return false
}
